jQuery(document).ready(function ($) {
  // AOS.init();
  //Menu JS
  $(".hamburger").click(function () {
    console.log("clicked");
    $(".hamburger--menu").stop(true, true).fadeIn();
    /* Note: For Only POP UP Menu */
    $("body").addClass("js-mobile-menu-open");
    /* Note: For Only POP UP Menu */
    // $(".hamburger").toggleClass("spin");
  });

  $("img.close-hmenu").click(function (e) {
    e.preventDefault();
    $(".hamburger--menu").stop(true, true).fadeOut();
    $(".hamburger").removeClass("spin");
    $(".sub-menu").removeClass("arrowopen");

    /* Note: For Only POP UP Menu */
    $("body").removeClass("js-mobile-menu-open");
    $(".sub-menu").removeClass("subMenu");
    /* Note: For Only POP UP Menu */
  });

  $(".mobile-menu .menu-item-has-children > a").append(
    "<span class='arrow'></span>"
  );

  $(".mobile-menu .menu-item-has-children > a span.arrow").click(function (e) {
    e.preventDefault();

    $(this)
      .parents("a")
      .next(".sub-menu")
      .stop(true, true)
      .toggleClass("subMenu");

    $(this).toggleClass("arrowopen");

    let currentParent = $(this).parents("li");

    // Remove Submenu class from of any other li that's not the current li clicked

    $("li.menu-item-has-children")
      .not(".sub-menu li.menu-item-has-children")
      .not(currentParent)
      .find("ul")
      .removeClass("subMenu");

    // Remove arrowopen class from any other li (Not submenu li) that's not the currently clicked parent menu
    $("li.menu-item-has-children")
      .not(".sub-menu li.menu-item-has-children")
      .not(currentParent)
      .find("a span.arrow")
      .removeClass("arrowopen");
  });

  $(window).resize(function () {
    var winwidth = $(window).width();
    if (winwidth > 1160) {
      $(".hamburger--menu").stop(true, true).slideUp();
      $(".hamburger").removeClass("spin");
      $("body").removeClass("js-mobile-menu-open");
    }
  });

  // Get the dimensions and position of the Nav Menu

  function subMenuPosition(Nav) {
    var NavWidth = Nav.width();
    var NavHeight = Nav.height();
    var NavOffset = Nav.offset();
    var NavLeft = NavOffset.left;
    var NavTop = NavOffset.top;

    // Get the dimensions of the viewport
    var viewportWidth = $(window).width();
    var viewportHeight = $(window).height();

    // Check if the Nav is going off the screen
    var isNavGoingOffScreen =
      NavLeft < 0 ||
      NavLeft + NavWidth > viewportWidth ||
      NavTop < 0 ||
      NavTop + NavHeight > viewportHeight;

    return isNavGoingOffScreen;
  }

  var subMenu = $("li.menu-item-has-children");
  $(subMenu).hover(function () {
    var Nav = $($(this).find(".sub-menu"));
    var isNavGoingOffScreen = subMenuPosition(Nav);

    if (isNavGoingOffScreen) {
      Nav.css("right", "0px");
    }
  });

  var subMenu = $(
    "li.menu-item-has-children .sub-menu li.menu-item-has-children"
  );
  $(subMenu).hover(function () {
    var Nav = $($(this).find(".sub-menu"));
    var isNavGoingOffScreen = subMenuPosition(Nav);
    if (isNavGoingOffScreen) {
      Nav.css("right", "100%");
      Nav.css("left", "unset");
    }
  });

  //Vide Background JS
  function scaleToFill() {
    $("video.video-background").each(function (videoTag) {
      var $video = $(videoTag),
        videoRatio = videoTag.videoWidth / videoTag.videoHeight,
        tagRatio = $video.width() / $video.height(),
        val;

      if (videoRatio < tagRatio) {
        val = (tagRatio / videoRatio) * 1.02;
      } else if (tagRatio < videoRatio) {
        val = (videoRatio / tagRatio) * 1.02;
      }

      $video.css("transform", "scale(" + val + "," + val + ")");
    });
  }

  $(function () {
    scaleToFill();

    $(".video-background").on("loadeddata", scaleToFill);

    $(window).resize(function () {
      scaleToFill();
    });
  });

  $(".mt-video .play").click(function () {
    if ($(this).parent().prev().get(0).paused) {
      $(this).parent().prev().get(0).play();
      $(this).parent().prev().removeClass("blurEffect");
      $(this).parent().prev().attr("controls", "controls");
      $(this).hide();
    } else {
      $(this).parent().prev().get(0).pause();
      $(this).fadeIn();
      $(this).parent().prev().removeAttr("controls");
    }
  });

  $(".mt-video .video").on("ended", function () {
    $(this).addClass("blurEffect");
    $(this).removeAttr("controls");
    $(this).parent().find(".play").fadeIn();
  });

  // BacktoTOP JS

  $(".backToTop img").on("click", function (e) {
    e.preventDefault();
    $("html, body").animate({ scrollTop: 0 }, 600);
  });

  var col = $(".col");
  $(col).each(function () {
    if (this.href === window.location.href) {
      $(this).closest(".col").addClass("active");
    }
  });


  // Counter JS

  function animateValue(obj, start, end, duration) {
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      obj.innerHTML = Math.floor(
        progress * (end - start) + start
      ).toLocaleString(); // Add commas
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }

  const obj = document.querySelectorAll("#value");
  obj.forEach((item) => {
    const countValue = parseFloat(item.innerText.replace(/,/g, "")); // Remove commas and parse as float

    // Only run animation if countValue is an integer (no decimal points)
    if (Number.isInteger(countValue)) {
      animateValue(item, 0, countValue, 3000);
    }
  });
});



